import React, { useState, useEffect } from 'react';
import Select from "react-select";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const translations = {
//   en: 'Test rate is ₹',
//   hi: 'परीक्षण शुल्क ₹',
//   te: 'పరీక్ష రేటు ₹',
//   ur: 'ٹیسٹ ریٹ ₹',
//   kn: 'ಪರೀಕ್ಷಾ ದರ ₹',
//   bn: 'পরীক্ষার দাম ₹',
//   mr: 'चाचणी दर ₹',
// };

const languageMap = {
  en: 'English',
  hi: 'Hindi (हिन्दी)',
  te: 'Telugu (తెలుగు)',
  ur: 'Urdu (اردو)',
  kn: 'Kannada (ಕನ್ನಡ)',
  bn: 'Bengali (বাংলা)',
  mr: 'Marathi (मराठी)',
};

const Test = () => {
  const [language, setLanguage] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [testList, setTestList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [branchOptions, setBranchOptions] = useState([]);
const [selectedBranch, setSelectedBranch] = useState(null);
const [services, setServices] = useState([]);
  const itemsPerPage = 10;

  // Fetch state list
  useEffect(() => {
    fetch(`${API_BASE_URL}test_maharashtra_details`)
      .then((res) => res.json())
      .then((data) => {
        if (data.STATUS && Array.isArray(data.data)) {
          setStateList(data.data);
        }
      })
      .catch((err) => {
        console.error('Error fetching state data:', err);
      });
  }, []);

  // Fetch test list (static)
  useEffect(() => {
    if (selectedState && selectedArea && language) {
      const selectedLang = languageMap[language]?.split(' ')[0] || 'English';
      const test_language = selectedLang === 'English'
        ? ['English']
        : [selectedLang, 'English'];

      const payload = {
        state: selectedState,
        territory: selectedArea,
        test_language
      };

      fetch(`${API_BASE_URL}test_rate_details`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.STATUS && Array.isArray(data.data)) {
            setTestList(data.data);
            setCurrentPage(1);
          } else {
            setTestList([]);
          }
        })
        .catch((err) => {
          console.error('Error fetching test rates:', err);
          setTestList([]);
        });
    }
  }, [selectedState, selectedArea, language]);


  // Fetch cities whenever selectedState changes
  useEffect(() => {
    if (selectedState) {
      fetch(`${API_BASE_URL}test_city_details/${selectedState}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.STATUS && Array.isArray(data.data)) {
            const cities = data.data.map((item) => item.territory_name);
            setCityList(cities);

            // ✅ Auto-select city if only one
            if (cities.length === 1) {
              setSelectedArea(cities[0]);
            } else {
              setSelectedArea('');
            }
          }
        })
        .catch((err) => {
          console.error('Error fetching city data:', err);
        });
    }
  }, [selectedState]);

  useEffect(() => {
  if (!selectedArea) return;

  fetch(`${API_BASE_URL}test_branch_details/${selectedArea}`)
    .then((res) => res.json())
    .then((data) => {
      console.log("Branch API:", data); // debug

      if (data.STATUS && Array.isArray(data.data)) {
        const formatted = data.data.map((b) => ({
          value: b.SysNo,
          label: b.SysField
        }));

        setBranchOptions(formatted);
      } else {
        setBranchOptions([]);
      }
    })
    .catch((err) => console.error("Branch Fetch Error:", err));
}, [selectedArea]);


useEffect(() => {
  if (!selectedBranch) return;

  const payload = {
    BranchId: Number(selectedBranch.value),   // SysNo
    PageNum: 1,
    PageSize: 5000
  };

  fetch("https://vlims.vijayadiagnostic.com/vpc.api/api/public/Public/GetDOServices", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  })
    .then((res) => res.json())
    .then((data) => {
      console.log("DO Services Response:", data);

      if (data?.status && Array.isArray(data.data)) {
        setServices(data.data);
      } else {
        setServices([]);
      }
    })
    .catch((err) => console.error("Error fetching DO services:", err));
}, [selectedBranch]);


  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem('selectedLanguage', lang);
  };

  const filteredList = testList.filter((item) =>
    item.test_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredList.length / itemsPerPage);
  const displayedItems = filteredList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const styles = {
    container: {
      fontFamily: 'Arial, sans-serif',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #e0f7fa, #fce4ec)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px',
      boxSizing: 'border-box',
    },
    card: {
      backgroundColor: '#ffffff',
      padding: '30px 20px',
      borderRadius: '16px',
      width: '100%',
      maxWidth: '900px',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.1)',
      position: 'relative', // 💡 important to anchor the floating sidebar within the card
    },
    headerTop: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    logo: {
      width: '160px',
      height: 'auto',
    },
    title: {
      fontSize: '20px',
      color: '#00796b',
      textAlign: 'center',
      marginTop: '10px',
    },
    callLink: {
      textDecoration: 'none',
      color: '#00796b',
      fontWeight: 'bold',
      fontSize: '16px',
    },
    label: {
      fontWeight: 'bold',
      textAlign: 'center',
      marginTop: '15px',
    },
    input: {
      width: '100%',
      padding: '10px',
      fontSize: '16px',
      borderRadius: '8px',
      border: '1px solid #ccc',
    },
    row: {
      marginBottom: '10px',
    },
    list: {
      listStyle: 'none',
      padding: 0,
    },
    listItem: {
      backgroundColor: '#f1f8e9',
      padding: '10px',
      borderRadius: '8px',
      marginBottom: '8px',
    },
    pagination: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '10px',
    },
    pageButton: {
      margin: '0 4px',
      padding: '6px 12px',
      border: '1px solid #00796b',
      borderRadius: '6px',
      cursor: 'pointer',
    },
    activePage: {
      backgroundColor: '#00796b',
      color: '#fff',
    },
    langButtonGroup: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '10px',
      margin: '10px 0',
    },
    footer: {
      textAlign: 'center',
      marginTop: '10px',
      fontSize: '14px',
      color: '#777',
    },
    langButton: (active) => ({
      padding: '8px 16px',
      borderRadius: '20px',
      border: '1px solid #00796b',
      backgroundColor: active ? '#00796b' : '#fff',
      color: active ? '#fff' : '#00796b',
      cursor: 'pointer',
    }),

    // 👉 Floating Sidebar Styles
    sidebarToggle: {
      backgroundColor: '#00796b',
      color: '#fff',
      border: 'none',
      borderRadius: '50%',
      padding: '6px 10px',
      fontSize: '18px',
      cursor: 'pointer',
      marginTop: '10px',
      alignSelf: 'flex-end',
      transition: 'background 0.3s',
    },

    floatingSidebar: {
      position: 'absolute',
      top: '110px', // adjust as needed
      right: '40px', // move it inside the card instead of floating out
      transform: 'translateX(-10%)', // push it to the left of the toggle
      backgroundColor: '#ffffff',
      border: '1px solid #ccc',
      borderRadius: '8px',
      boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
      padding: '10px',
      zIndex: 100,
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      minWidth: '140px',
    },

    sidebarLink: {
      backgroundColor: '#00796b',
      color: '#fff',
      textDecoration: 'none',
      padding: '8px 12px',
      borderRadius: '6px',
      textAlign: 'center',
      fontSize: '13px',
    },
  };


  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.headerTop}>
          <img src="assets/images/Logos.png" alt="VDC Logo" style={styles.logo} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <a href="tel:9240222222" style={styles.callLink}>📞 9240 222 222</a>
            <a
              href="https://api.whatsapp.com/send/?phone=919121999111&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer"
              style={{ ...styles.callLink, fontSize: '15px', marginTop: '4px' }}
            >
              <img
                src="assets/images/wtsapp.png"
                alt="WhatsApp"
                style={{ height: '28px', width: '28px' }}
              />
            </a>
            {/* Toggle Button */}
            <button onClick={() => setSidebarOpen(!sidebarOpen)} style={styles.sidebarToggle}>
              {sidebarOpen ? '✖' : '☰'}
            </button>

            {/* Floating Sidebar */}
            {sidebarOpen && (
              <div style={styles.floatingSidebar}>
                <a href="https://www.vijayadiagnostic.com/test/hyderabad" target="_blank" style={styles.sidebarLink}>📅 Book a Test</a>
                <a href="https://www.vijayadiagnostic.com/find-a-centre" target="_blank" style={styles.sidebarLink}>📍 Find a Centre</a>
                <a href="https://www.vijayadiagnostic.com/mydashboard?type=2" target="_blank" style={styles.sidebarLink}>📄 Download Report</a>
                <a href="https://www.vijayadiagnostic.com/health-checkup" target="_blank" style={styles.sidebarLink}>💰 Health Packages</a>
              </div>
            )}
          </div>
        </div>


        <h2 style={styles.title}>Vijaya Diagnostic Centre</h2>

        {/* State Selection */}
        <div style={styles.label}>Choose Your State</div>
        <div style={styles.langButtonGroup}>
          {stateList.map((state, idx) => (
            <button
              key={idx}
              onClick={() => {
                setSelectedState(state.state_name);
                setLanguage(
                  state.state_name.toLowerCase() === 'karnataka' ? 'kn' :
                    state.state_name.toLowerCase() === 'westbengal' ? 'bn' :
                      state.state_name.toLowerCase() === 'maharashtra' ? 'mr' :
                        state.state_name.toLowerCase() === 'haryana' ? 'hi' :
                          ['telangana', 'andhrapradesh'].includes(state.state_name.toLowerCase()) ? 'te' : ''
                );
              }}
              style={styles.langButton(selectedState === state.state_name)}
            >
              {state.state_name}
            </button>
          ))}
        </div>

        {/* City Selection */}
        {selectedState && (
          <>
            <div style={styles.label}>Choose Your City/Branch</div>
            <div style={styles.langButtonGroup}>
              {cityList.map((city, idx) => (
                <button
                  key={idx}
                  onClick={() => setSelectedArea(city)}
                  style={styles.langButton(selectedArea === city)}
                >
                  {city}
                </button>
              ))}
            </div>
          </>
        )}

        <Select
  options={branchOptions}
  value={selectedBranch}
  onChange={setSelectedBranch}
  placeholder="Select Branch"
  isSearchable
  styles={{
    container: (base) => ({ ...base, width: "100%" }),
    menu: (base) => ({ ...base, zIndex: 9999 }),
  }}
/>

<ul>
  {services.map((s, index) => (
    <li key={index}>{s.ServiceName}</li>
  ))}
</ul>

        {/* Language Selection */}
        <div style={styles.label}>Choose Your Language</div>
        <div style={styles.langButtonGroup}>
          {Object.entries(languageMap).map(([code, label]) => (
            <button
              key={code}
              onClick={() => handleLanguageChange(code)}
              style={styles.langButton(language === code)}
            >
              {label}
            </button>
          ))}
        </div>

        {/* Test List */}
        {selectedArea && language ? (
          <>
            <div style={styles.row}>
              <input
                type="text"
                placeholder="Search test..."
                style={styles.input}
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>

            {/* <ul style={styles.list}>
              {displayedItems.map((item, idx) => (
                <li key={idx} style={styles.listItem}>
                  {item.test_name} - <b>₹{item.rate}</b>
                </li>
              ))}
            </ul> */}

            <div
  style={{
    position: 'relative',
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
  }}
>
  {/* First watermark logo */}
  <img
    src="assets/images/vdc_logo.png"
    alt="Watermark Logo 1"
    style={{
      position: 'absolute',
      top: '10%',
      left: '15%',
      opacity: 1.45,
      width: '200px',
      pointerEvents: 'none',
      zIndex: 0,
    }}
  />

  {/* Second watermark logo */}
  <img
    src="assets/images/vdc_logo.png"
    alt="Watermark Logo 2"
    style={{
      position: 'absolute',
      bottom: '10%',
      right: '15%',
      opacity: 1.45,
      width: '200px',
      pointerEvents: 'none',
      zIndex: 0,
    }}
  />

  {/* List content goes here */}
  <ul
    style={{
      ...styles.list,
      position: 'relative',
      zIndex: 1,
      padding: 0,
      margin: 0,
      width: '100%',
    }}
  >
    {displayedItems.map((item, idx) => (
      <li
        key={idx}
        style={{
          ...styles.listItem,
          backgroundColor: 'rgba(241, 248, 233, 0.85)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '12px 15px',
          fontSize: '14px',
          flexWrap: 'wrap',
        }}
      >
        <div
          style={{
            direction: 'ltr',
            fontFamily: 'Noto Nastaliq Urdu, serif',
            flex: 1,
            minWidth: '50%',
          }}
        >
          {item.test_name}
        </div>
        <div style={{ marginLeft: '10px', whiteSpace: 'nowrap' }}>
          <b>₹{item.rate}</b>
        </div>
      </li>
    ))}
  </ul>
</div>




            <div style={styles.pagination}>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  style={{
                    ...styles.pageButton,
                    ...(page === currentPage ? styles.activePage : {}),
                  }}
                >
                  {page}
                </button>
              ))}
            </div>
          </>
        ) : (
          <p style={{ textAlign: 'center', color: '#d32f2f' }}>
            Please select both state, city and language to view test tariffs.
          </p>
        )}

        <div style={styles.footer}>

          {/* <br />
          <br /> */}

          For feedback: feedback@vijayadiagnostic.in
          <br />
          {/* <br /> */}
          <b style={{

            fontSize: '10px', // reduced font size
          }}>*Kindly reach our billing staff for tariff details as on date</b>
          <br />
          {/* <br /> */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', flexWrap: 'wrap' }}>
            <a href="https://bit.ly/vdcappn" target="_blank" rel="noopener noreferrer">
              <img src="assets/images/playstore.png" alt="Download on Play Store" style={{ height: '40px' }} />
            </a>
            <a href="https://apple.co/3SwQoww" target="_blank" rel="noopener noreferrer">
              <img src="assets/images/appstore.png" alt="Download on App Store" style={{ height: '40px' }} />
            </a>

          </div >
          &copy; <span style={{

            fontSize: '10px', // reduced font size
          }}>2025 Vijaya Diagnostic Centre. All rights reserved.</span>
        </div>
      </div>



    </div>
  );
};

export default Test;
